/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

// ---------------------------------------------
// HEY, USING HUD IN THIS WAY IS PROBABLY WRONG
// the sane thing would probably be to update the world in pixi, then use that to update the HUD
// instead of updating the hud from pixi events, then listening to the hud to update the world
// ---------------------------------------------

import { Interaction } from 'src/app/plain-javascript/services/interaction-blocker';
import { DisplayObject } from 'pixi.js-legacy';
import { Component } from '@appCanvasCommon/component-system/Component';
import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { EventBinder } from '../interaction-utils';
import { analyticsEventsService } from 'src/app/plain-javascript/services/analytics/AnalyticsEventsService';

import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
import { CONTEXT_MENUS } from 'src/app/modules/ticket-edit/context-menu.service';

export class PlanTap extends Component implements ComponentInterface {
	private _binder: EventBinder;
	constructor() {
		super();
	}
	/**
	 * The setup method is called once all properties on a component have been decorated by the ComponentManager.
	 *
	 * From this point on, you can safely use this.getParent() and this.getManager().
	 *
	 * Arguments passed into setup are passed in via the ComponentManager.add(name, component, ...args)
	 */
	public override setup(canvasAngularLand: CanvasAngularLand, parent: DisplayObject): void {
		this.canvasAngularLand = canvasAngularLand;
		this._binder = new EventBinder(parent);

		this._binder.add('hammer-singletap', (event) => {
			const tickets = canvasAngularLand.tickets.selectedTicket$.getValue();
			if (
				canvasAngularLand.interactionBlocker.check(Interaction.TapPlan, {
					tickets: tickets.list,
				})
			) {
				const count = tickets.list.size;
				const planId = canvasAngularLand.route.snapshot.paramMap.get('planId');
				analyticsEventsService.multiselectTapPlanToCancel(count, planId);
				canvasAngularLand.actions.clearSelection(tickets.list);
			}
			//always clear floating tickets
			const floatingTickets = canvasAngularLand.floatingTickets;
			if (floatingTickets.selectedTicket$.getValue().list.size) {
				canvasAngularLand.actions.unSelectTicket(
					floatingTickets.selectedTicket$.getValue().list,
					floatingTickets
				);
			}

			canvasAngularLand.contextMenuService.hide(CONTEXT_MENUS.TICKET_QUICK_STATUS);
			canvasAngularLand.contextMenuService.hide(CONTEXT_MENUS.TICKET_EDIT_CONFIRM_MENU);

			canvasAngularLand.hoverOverStateService.endHover();
			canvasAngularLand.hoverOverStateService.endHoverComponent();
			canvasAngularLand.timelineTicketService.closeOverflow();
		});
	}

	/**
	 * ...must...kill...stuff....here
	 */
	public override destroy() {
		super.destroy();
		this._binder.destroy();
	}
}
